import { Controller } from "@hotwired/stimulus"
import { copyHtmlAndText, copyText } from "../util/clipboard"

// Connects to data-controller="copy-to-clipboard"
export default class extends Controller {
  static targets = ["source", "button", "buttonContent"]
  static values = {
    withAnimation: {
      type: Boolean,
      default: true
    },
    isIcon: {
      type: Boolean,
      default: true
    },
    buttonText: {
      type: String,
      default: "Copy"
    }
  }

  async copy(event) {
    event.preventDefault()

    try {
      if (this.isSourceInput()) {
        await copyText(this.getText())
      } else {
        await copyHtmlAndText(this.getHTML(), this.getText())
      }

      if (this.withAnimationValue)
        this.showCopiedState()
    } catch (error) {
      console.error("Failed to copy:", error)
    }
  }

  getText() {
    if (this.isSourceInput())
      return this.sourceTarget.value.trim()

    return this.sourceTarget.textContent.trim()
  }

  getHTML() {
    return this.sourceTarget.innerHTML
  }

  isSourceInput() {
    const tagName = this.sourceTarget.tagName.toLowerCase()
    return ["textarea", "input"].includes(tagName)
  }

  showCopiedState() {
    clearTimeout(this.timeout)

    const copyButton = this.buttonTarget
    const copyButtonContent = this.buttonContentTarget

    copyButton.classList.add("copied")
    copyButtonContent.innerHTML = this.isIconValue ? '<i class="fa-solid fa-check fa-sm"></i>' : "Copied!"

    this.timeout = setTimeout(() => {
      copyButton.classList.remove("copied")
      copyButtonContent.innerHTML = this.isIconValue ? '<i class="fa-solid fa-copy fa-sm"></i>' : this.buttonTextValue
    }, 2000)
  }
}
